import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { OptionEditModalForm } from './OptionEditModalForm'
import { isNotEmpty, QUERIES } from '../../../../../_dashboard/helpers'
import { useListView } from '../core/ListViewProvider'
import { getOneByIdbylang } from '../../../../services/common_requests'
import { Option, initialOption } from '../core/_models'

const OPTION_MODAL_CREATE_TEMPLATE: Option = {
  ...initialOption,
  _id: undefined,
  translations: (initialOption.translations || [{ language: 'en', title: '' }]).map((t) => ({ ...t })),
}

const OptionEditModalFormWrapper = () => {
  const { itemIdForUpdate, setItemIdForUpdate } = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  const optionLoadingShell = useMemo((): Option => {
    return {
      ...OPTION_MODAL_CREATE_TEMPLATE,
      _id: itemIdForUpdate,
      translations: OPTION_MODAL_CREATE_TEMPLATE.translations.map((t) => ({ ...t })),
    }
  }, [itemIdForUpdate])

  const {
    isLoading,
    data: Option,
    error,
  } = useQuery(
    `${QUERIES.OPTION_LIST}-Option-${itemIdForUpdate}`,
    () => {
      return getOneByIdbylang(`/options/${itemIdForUpdate}?language=all`)
    },
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: () => {
        setItemIdForUpdate(undefined)
      },
    },
  )

  if (!itemIdForUpdate) {
    return <OptionEditModalForm isOptionLoading={isLoading} Option={OPTION_MODAL_CREATE_TEMPLATE} />
  }

  if (enabledQuery && (isLoading || (!error && !Option))) {
    return <OptionEditModalForm isOptionLoading={true} Option={optionLoadingShell} />
  }

  if (!isLoading && !error && Option) {
    return <OptionEditModalForm isOptionLoading={false} Option={Option} />
  }

  return <OptionEditModalForm isOptionLoading={false} Option={optionLoadingShell} />
}

export { OptionEditModalFormWrapper }
